import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import ProductOptions from './product-options.js';

window.productOptions = ProductOptions;

require('flickity-as-nav-for');
require('flickity-fade');

import './main.css';

import './anim.js';

import Alpine from 'alpinejs';
import { animate, inView, scroll } from 'motion';
import Cart from './cart';
import Filters from './filters.js';
import BlogFilters from './blog-filters.js';
import BenefitDetails from './benefits-details.js';
import ProductCta from './product-cta';
import ProductModal from './modal.js';

Cart();
Filters();
BlogFilters();
ProductCta();
ProductModal();

window.Alpine = Alpine;

window.rcLoginAccessLink = {
  translation: {
    en: {
      titleText: 'Manage your new Subscribe & Save account',
      linkText: 'Manage your new Subscribe & Save account',
    },
  },
};

Alpine.magic('money', (el, { Alpine }) => {
  return (cents, format) => {
    if (format) {
      format = '£{{' + format + '}}';
    }

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '£{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
});

Alpine.start();

const init = () => {
  if (document.querySelector('.quantity-number-input')) {
    const quantityInputs = document.querySelectorAll('.quantity-number-input');
    const updateTotalsButton = document.querySelector('#update-totals-button');
    let changeTimer; //timer identifier
    let changeInterval = 1000; //time in ms (5 seconds)

    quantityInputs.forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(changeTimer);
        if (input.value) {
          changeTimer = setTimeout(updateTotals, changeInterval);
        } else {
        }
      });
    });

    function updateTotals() {
      updateTotalsButton.click();
    }
  }

  var mobTitles = document.querySelectorAll('.mob-title');

  mobTitles.forEach(function (mobTitle) {
    let mobSibling = mobTitle.nextElementSibling;
    if (mobSibling) {
      mobTitle.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobSibling.classList.contains('translate-x-full')) {
          mobSibling.classList.remove('translate-x-full');
          mobSibling.classList.remove('opacity-0');
          mobSibling.classList.remove('pointer-events-none');
          mobSibling.classList.add('submenu-open');
        } else {
          mobSibling.classList.add('translate-x-full');
          mobSibling.classList.add('opacity-0');
          mobSibling.classList.add('pointer-events-none');
          mobSibling.classList.remove('submenu-open');
        }
      });

      let backBtn = mobSibling.querySelector('.menu-back');
      backBtn.addEventListener('click', function () {
        let subMenuParent = this.parentElement;
        subMenuParent.classList.add('translate-x-full');
        subMenuParent.classList.add('opacity-0');
        subMenuParent.classList.add('pointer-events-none');
        subMenuParent.classList.remove('submenu-open');
      });
    }
  });

  if (document.querySelector('.main-product-carousel')) {
    var options = {
      accessibility: true,
      prevNextButtons: false,
      pageDots: window.innerWidth < 1024 ? true : false,
      imagesLoaded: true,
    };

    var navOptions = {
      asNavFor: '.main-product-carousel',
      draggable: true,
      groupCells: '100%',
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
    };
    if (document.querySelector('[data-mainproductcarousel]')) {
      var mainCarousel = new Flickity(document.querySelector('[data-mainproductcarousel]'), options);
      var productNavCarousel = new Flickity(document.querySelector('[data-productNavCarousel]'), navOptions);
      var navParent = document.querySelector('.product-nav-wrapper');

      customSliderBtns(navParent, productNavCarousel);
    }
  }

  if (document.querySelector('.announcement-slider')) {
    var options = {
      prevNextButtons: false,
      pageDots: false,
      autoPlay: true,
      autoPlay: 8000,
      wrapAround: true,
      cellAlign: 'center',
    };

    var announcementSlider = document.querySelector('.announcement-slider');

    var announcement = new Flickity(announcementSlider, options);
  }

  BenefitDetails();

  const relatedProductSlider = document.querySelector('.relatedproduct-carousel');
  if (relatedProductSlider) {
    const relatedOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: 'fill',
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      cellAlign: 'left',
    };

    var relatedSlider = new Flickity(relatedProductSlider, relatedOptions);

    const dotsWrapper = document.createElement('div');
    dotsWrapper.classList.add('dots-wrapper');

    var dotsBtns = relatedProductSlider.querySelector('.flickity-page-dots');

    dotsBtns.parentNode.insertBefore(dotsWrapper, dotsBtns);

    customSliderBtns(dotsWrapper, relatedSlider, dotsBtns, true);
  }

  const tripleCardSlider = document.querySelector('.triplecard-carousel');
  if (tripleCardSlider) {
    const tripleOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      watchCSS: true,
    };

    var tripleSlider = new Flickity(tripleCardSlider, tripleOptions);
  }

  const bannerSlider = document.querySelector('.banner-carousel');
  if (bannerSlider) {
    const bannerOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      autoPlay: true,
      autoPlay: 12000,
      pageDots: true,
      imagesLoaded: true,
      lazyLoad: 1,
    };

    var banner = new Flickity(bannerSlider, bannerOptions);
    customSliderBtns(bannerSlider, banner, null, true);
  }
  const filterSlider = document.querySelector('.filter-carousel');
  if (filterSlider) {
    const filterOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      autoPlay: false,
      pageDots: false,
      imagesLoaded: true,
      contain: true,
      cellAlign: 'left',
    };

    if (window.innerWidth < 1024) {
      filterSlider.classList.add('flex');
      filterSlider.classList.add('overflow-auto');
    } else {
      var filters = new Flickity(filterSlider, filterOptions);
      customSliderBtns(filterSlider, filters, null, false);
    }
  }

  const reviewSlider = document.querySelector('.reviews-slider');
  if (reviewSlider) {
    const reviewOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      fade: true,
      lazyLoad: true,
    };

    var reviews = new Flickity(reviewSlider, reviewOptions);

    const dotsWrapper = document.createElement('div');
    dotsWrapper.classList.add('dots-wrapper');

    var dotsBtns = reviewSlider.querySelector('.flickity-page-dots');

    dotsBtns.parentNode.insertBefore(dotsWrapper, dotsBtns);

    customSliderBtns(dotsWrapper, reviews, dotsBtns, true);
  }

  const logoSlider = document.querySelectorAll('.logo-slider');
  const mobileLogoSlider = document.querySelectorAll('.mobile-logo-slider');

  if (logoSlider.length > 1) {
    const logoOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: 'fill',
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      cellAlign: 'left',
      lazyLoad: true,
    };

    logoSlider.forEach((slider) => {
      logoSlide = new Flickity(slider, logoOptions);
    });
  }

  if (mobileLogoSlider.length > 1) {
    const logoOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      cellAlign: 'left',
      watchCSS: 'true',
      lazyLoad: true,
    };

    mobileLogoSlider.forEach((slider) => {
      logoSlide = new Flickity(slider, logoOptions);
    });
  }

  var blogSlider = document.querySelector('.blog-slider');

  if (blogSlider) {
    const blogOptions = {
      accessibility: true,
      draggable: true,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      cellAlign: 'left',
      lazyLoad: true,
    };

    var blogSlide = new Flickity(blogSlider, blogOptions);
  }

  // Login/Register redirect to checkout
  const currentUrl = new URL(window.location.href);
  const hasCheckoutRedirect = currentUrl.searchParams.has('checkout_login');

  if (document.body.classList.contains('template-customers-login') && hasCheckoutRedirect) {
    document.querySelector('a[href="/account/register"]').setAttribute('href', '/account/register?checkout_login=true');
  } else if (document.body.classList.contains('template-customers-register') && hasCheckoutRedirect) {
    const redirectInput = document.createElement('input');

    redirectInput.setAttribute('name', 'return_to');
    redirectInput.setAttribute('type', 'hidden');
    redirectInput.setAttribute('value', '/checkout');

    document.getElementById('create_customer')?.append(redirectInput);
  }
  
  // document.body.classList.contains('.template-customers-register') ||
};

function customSliderBtns(carouselWrapper, targetSlider, inlineDots = null, wrapAround = false) {
  const prevButton = document.createElement('button');
  prevButton.classList.add('custom-prev-button', 'previous');
  prevButton.innerHTML = '<i class="fa-sharp fa-light fa-arrow-left"></i>';

  const nextButton = document.createElement('button');
  nextButton.classList.add('custom-next-button', 'next');
  nextButton.innerHTML = '<i class="fa-sharp fa-light fa-arrow-right"></i>';

  carouselWrapper.appendChild(prevButton);
  if (inlineDots) {
    carouselWrapper.appendChild(inlineDots);
  }
  carouselWrapper.appendChild(nextButton);

  prevButton.addEventListener('click', () => {
    targetSlider.previous();
  });

  nextButton.addEventListener('click', () => {
    targetSlider.next();
  });

  function updateButtonStates() {
    if (!wrapAround) {
      const isAtStart = targetSlider.selectedIndex === 0;
      const isAtEnd = targetSlider.selectedIndex === targetSlider.slides.length - 1;

      prevButton.classList.toggle('disabled', isAtStart);
      nextButton.classList.toggle('disabled', isAtEnd);
    }
  }

  if (!wrapAround) {
    targetSlider.on('select', updateButtonStates);
    updateButtonStates();
  }
}

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}
